application.register("part_ui_tomselect", class extends Stimulus.Controller {
    connect() {
        const select = this.element.querySelector('select')
        importStyle(cdnjs.tomselect_css)

        importScript(cdnjs.tomselect, () => {
            var options = {
                plugins: {
                    remove_button:{
                        title:'Remove this item',
                    }
                },
                placeholder: this.element.querySelector('label') ? '' : undefined,
                onInitialize: () => {
                    if(select.value !== '') {
                        this.element.classList.add('state--active')
                    }
                },
                onDropdownOpen: (dropdown) => {
                    this.element.classList.add('state--focus')
                },
                onDropdownClose: (dropdown) => {
                    this.element.classList.remove('state--focus')
                },
                onChange: (value) => {
                    if (value.length > 0) {
                        this.element.classList.add('state--active')
                    } else {
                        this.element.classList.remove('state--active')
                    }
                }
            }

            this._tomselect = new TomSelect(select, options)
        })
    }
})
